import { render } from "./UserWallet.vue?vue&type=template&id=4c31493c&scoped=true"
import script from "./UserWallet.vue?vue&type=script&lang=js"
export * from "./UserWallet.vue?vue&type=script&lang=js"

import "./UserWallet.vue?vue&type=style&index=0&id=4c31493c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c31493c"]])

export default __exports__